"use strict";
/*
  based on: https://github.com/rzeigler/waveguide-streams/blob/master/src/step.ts
  credits to original author
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var SinkStepTag;
(function (SinkStepTag) {
    SinkStepTag[SinkStepTag["Cont"] = 0] = "Cont";
    SinkStepTag[SinkStepTag["Done"] = 1] = "Done";
})(SinkStepTag = exports.SinkStepTag || (exports.SinkStepTag = {}));
function sinkCont(s) {
    return { _tag: SinkStepTag.Cont, state: s };
}
exports.sinkCont = sinkCont;
function sinkDone(s, leftover) {
    return { _tag: SinkStepTag.Done, state: s, leftover: leftover };
}
exports.sinkDone = sinkDone;
function isSinkCont(s) {
    return s._tag === SinkStepTag.Cont;
}
exports.isSinkCont = isSinkCont;
function isSinkDone(s) {
    return s._tag === SinkStepTag.Done;
}
exports.isSinkDone = isSinkDone;
function sinkStepLeftover(s) {
    if (s._tag === SinkStepTag.Cont) {
        return [];
    }
    else {
        return s.leftover;
    }
}
exports.sinkStepLeftover = sinkStepLeftover;
function sinkStepState(s) {
    return s.state;
}
exports.sinkStepState = sinkStepState;
function map(step, f) {
    return __assign(__assign({}, step), { state: f(step.state) });
}
exports.map = map;
function mapWith(f) {
    return function (step) { return map(step, f); };
}
exports.mapWith = mapWith;
function traverse(F) {
    return function (step, f) { return F.map(f(step.state), function (s1) { return (__assign(__assign({}, step), { state: s1 })); }); };
}
exports.traverse = traverse;
